import Cookies from 'js-cookie'

/**
 * Gets an existing facebook click id (fbc) without setting or refreshing it
 * @returns The saved facebook click id (fbc), if it is set, or undefined otherwise
 */
const getFacebookClickId = () => Cookies.get('_fbc') || null

export default getFacebookClickId
